import { render, staticRenderFns } from "./AssetDetailsDefault.vue?vue&type=template&id=5da6024e"
import script from "./AssetDetailsDefault.vue?vue&type=script&lang=js"
export * from "./AssetDetailsDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports